<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        {{ this.$route.meta.title }}
        <div class="card-header-actions">
          <b-dropdown text="Action" variant="primary" class="mr-1">
            <b-dropdown-item @click="revisipinjaman">Revisi</b-dropdown-item>
            <b-dropdown-item @click="angsuran" :disabled="model.model_pinjaman == 'PRK'">Jadwal
              Angsuran</b-dropdown-item>
            <b-dropdown-item @click="createVa">Create VA</b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item @click="harianDtl">Detail Denda/Bunga RK</b-dropdown-item>
            <b-dropdown-item @click="pelunasan" :disabled="model.final !== 1">Permohonan Pelunasan</b-dropdown-item>
            <b-dropdown-item @click="paymentHistory" :disabled="model.final == 1">History Payment &
              Settlement</b-dropdown-item>
            <b-dropdown-item @click="exportDtl">Export Detail Pinjaman</b-dropdown-item>
          </b-dropdown>
          <b-dropdown text="Accrue" variant="primary" class="mr-1">
            <!-- <b-dropdown-item @click="startaccrue" :disabled="model.npf_stop_accrue !== 1"
              ><i :class="model.npf_stop_accrue !== 1?'fa fa-play':'fa fa-play fa-fw text-success'"></i>
              Reverse Stop </b-dropdown-item
            >
            <b-dropdown-item @click="stopaccrue" :disabled="model.npf_stop_accrue !== 0"
              ><i :class="model.npf_stop_accrue !== 0?'fa fa-stop':'fa fa-stop fa-fw text-danger'"></i>
              Stop</b-dropdown-item
            > -->

            <b-dropdown-item @click="writeoff" :disabled="model.npf_stop_accrue !== 1"><i :class="model.npf_stop_accrue !== 1
          ? 'fa fa-stop'
          : 'fa fa-stop fa-eraser text-danger'
          "></i>
              Write Off</b-dropdown-item>
          </b-dropdown>
          <button class="btn btn-primary mr-1" @click="showFilter = !showFilter">
            <i class="fa fa-filter"></i> Filter
          </button>
          <b-button variant="primary mr-1" @click="exportxls()">
            <i class="fa fa-file-excel-o"></i>Export
          </b-button>
          <button class="btn btn-primary mr-1" @click="close()">
            <i class="fa fa-close"></i> {{ $t("close") }}
          </button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6">
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Debitur</label>
                </b-input-group-prepend>
                <b-form-input v-model="tblData.customer" placeholder="Customer"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label style="width: 100px">No. Kontrak</label>
                </b-input-group-prepend>
                <b-form-input v-model="tblData.nomor" placeholder="No Kontrak"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Model Pinjaman</label>
                </b-input-group-prepend>
                <b-form-select v-model="tblData.model_pinjaman" :plain="true" :options="modelkredit"></b-form-select>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label style="width: 100px">No. Agreement</label>
                </b-input-group-prepend>
                <b-form-input v-model="tblData.agreement" placeholder="No Agreement"></b-form-input>
              </b-input-group>
              <!-- <b-input-group>
                <b-input-group-prepend>
                  <label style="width:100px;">Collector</label>
                </b-input-group-prepend>
                <b-form-select v-model="tblData.collector_id" :plain="true" :options="collectors"></b-form-select>
              </b-input-group> -->
            </b-col>
          </b-row>
        </b-col>
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend>
              <label>Days Over Due</label>
            </b-input-group-prepend>
            <my-number class="form-control text-right" separator="," v-model="tblData.dod1" :precision="0"
              style="min-width: 50px; max-width: 100px"></my-number>
            <b-input-group-prepend>
              <span class="input-group-text">until</span>
            </b-input-group-prepend>
            <my-number class="form-control text-right" separator="," v-model="tblData.dod2" :precision="0"
              style="min-width: 50px; max-width: 100px"></my-number>
            <b-input-group-prepend>
              <span class="ml-2 pt-2">Collector&nbsp;</span>
            </b-input-group-prepend>
            <b-form-select v-model="tblData.collector_id" :plain="true" :options="collectors"></b-form-select>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label class="pt-2">Kolektabilitas</label>
            </b-input-group-prepend>
            <b-form-select v-model="tblData.collectability" :plain="true" :options="kolStatus"></b-form-select>
            <b-input-group-prepend>
              <label class="px-2">Status Pinjaman</label>
            </b-input-group-prepend>
            <b-form-select v-model="tblData.contract_status" :plain="true" :options="statuses"></b-form-select>
          </b-input-group>
        </b-col>
        <b-col lg="5">
          <b-input-group>
            <b-input-group-prepend>
              <label>Tgl. Cair</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.tgl1" type="date"></b-form-input>
            <b-input-group-prepend>
              <span class="input-group-text">until</span>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.tgl2" type="date"></b-form-input>
            <b-input-group-prepend> </b-input-group-prepend>
          </b-input-group>
        </b-col>
        <b-col lg="7">
          <b-input-group>
            <b-input-group-prepend>
              <label>Status WO</label>
            </b-input-group-prepend>
            <b-form-select v-model="tblData.wo_status" :plain="true" :options="wostatus"></b-form-select>
            <b-input-group-prepend>
              <span class="ml-2 pt-2">Source Project&nbsp;</span>
            </b-input-group-prepend>
            <b-form-select v-model="tblData.pjxkey" :plain="true" :options="sourceproject"></b-form-select>
            <b-input-group-append>
              <b-button variant="success" size="sm" @click="refresh()" class="ml-3">
                <i class="fa fa-refresh"></i> Apply Filter
              </b-button>
            </b-input-group-append>
            <b-input-group-append>
              <b-button variant="secondary" size="sm" class="ml-2" @click="clearFilter()">Clear Filter</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <b-card no-body class="mb-0">
        <b-table class="mb-0" ref="table" outlined responsive striped hover style="font-size: smaller" :items="data"
          :fields="tblFields" :current-page="tblData.page" :per-page="tblData.limit" :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc" :key="tblData.limit" :busy="isBusy" @row-clicked="rowClicked" show-empty>
          <!-- <template v-slot:thead-top="data">
            <b-tr>
              <b-th colspan="10">
                <span class="sr-only">Detail Debitur</span>
              </b-th>
              <b-th variant="info" colspan="3" class="text-center">PAB</b-th>
              <b-th variant="success" colspan="1" class="text-center">PRK</b-th>
              <b-th colspan="7"></b-th>
            </b-tr>
          </template> -->
          <template v-slot:cell(index)="data">{{ data.index + 1 }}</template>
          <template v-slot:cell(tgl_kontrak)="data">{{
          data.item.tgl_kontrak | moment("DD/MM/YYYY")
        }}</template>
          <template v-slot:cell(plafon)="data">{{
          data.item.plafon | numFormat("0,0.00")
        }}</template>
          <template v-slot:cell(principal)="data">{{
          data.item.principal | numFormat("0,0.00")
        }}</template>
          <template v-slot:cell(plafond)="data">{{
          data.item.plafond | numFormat("0,0.00")
        }}</template>
          <template v-slot:cell(installment_amount)="data">{{
          data.item.installment_amount | numFormat("0,0.00")
        }}</template>
          <template v-slot:cell(denda_tarifhri)="data">{{
          data.item.denda_tarifhri | numFormat("0,0.0000")
        }}</template>
          <template v-slot:cell(bungaod_tarifbln)="data">{{
          data.item.bungaod_tarifbln | numFormat("0,0.00")
        }}</template>
          <template v-slot:cell(bunga_tarifthn)="data">{{
          data.item.bunga_tarifthn | numFormat("0,0.00")
        }}</template>
          <template v-slot:cell(tenor)="data">{{
          data.item.tenor | numFormat
        }}</template>
          <template v-slot:cell(startdate)="data">{{
          data.item.startdate | moment("DD/MM/YYYY")
        }}</template>
          <template v-slot:cell(duedate)="data">{{
          data.item.duedate | moment("DD/MM/YYYY")
        }}</template>
          <!-- <template v-slot:cell(collectability)="data">
            {{ data.item.collectability }}
            <span v-if="data.item.npf_stop_accrue" class="bg-danger p-1"
              >Stop Accrued</span
            >
            <span v-else class="bg-success p-1">Accrued </span>
          </template> -->
          <template v-slot:cell(npf_stop_accrue)="data">
            <span v-if="data.item.npf_stop_accrue" class="bg-danger p-1">Stop Accrued</span>
            <span v-else class="bg-success p-1">Accrued </span>
          </template>
          <template v-slot:cell(wo_status)="data">
            <span v-if="data.item.wo_status">WO</span>
            <span v-else>NORMAL</span>
          </template>

          <template v-slot:cell(rrd_dt)="data">
            <span v-if="(data.item.rrd_dt || '') != ''">{{
          data.item.rrd_dt | moment("DD/MM/YYYY")
        }}</span>
          </template>
          <template v-slot:table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template v-slot:cell(empty)="data">
            <h4>{{ data.emptyText }}</h4>
          </template>
          <template v-slot:cell(emptyfiltered)="data">
            <h4>{{ data.emptyFilteredText }}</h4>
          </template>
        </b-table>
      </b-card>

      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{ (tblData.page - 1) * tblData.limit + 1 }}
            to
            <span v-if="tblData.page * tblData.limit > tblData.total">{{
          tblData.total
        }}</span>
            <span v-else>{{ tblData.page * tblData.limit }}</span>
            of {{ tblData.total }} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-form-group label-cols="3" label style="margin-top: 0 !important">
            <b-input-group>
              <b-input-group-prepend class="mr-2">
                <label>Limit per page</label>
              </b-input-group-prepend>
              <div class="d-flex">
                <b-form-select :options="[10, 15, 20, 25]" :plain="true" v-model="tblData.limit" size="sm"
                  style="width: 80px" />
              </div>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-pagination align="right" :total-rows="tblData.total" :per-page="tblData.limit"
            v-model="tblData.page"></b-pagination>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import myNumber from "../../components/my-number";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
import pinjaman from "../../apis/pinjamankredit";
import project from "../../apis/project";
import crud from "../../apis/crud";

toastr.init();
export default {
  components: { myNumber, Loading },
  data() {
    return {
      showFilter: true,
      isBusy: false,
      model: {},
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        // tgl1: this.$store.state.user.tglaktif,
        // tgl2: this.$store.state.user.akhirbln,
        sortBy: "no_kontrak",
        sortDesc: false,
        model_pinjaman: "",
        collector_id: "",
        collectability: "",
        sourceproject: this.$store.state.user.compcode || "",
        contract_status: "",
        wo_status: "",
      },
      collectors: [{ value: "", text: "--- ALL ---" }],
      modelkredit: [
        { value: "", text: "--- ALL ---" },
        { value: "PAB", text: "Angsuran Bulanan (PAB)" },
        { value: "PRK", text: "Rekening Koran (PRK)" },
      ],
      kolStatus: [],
      statuses: [
        { value: "", text: "--- ALL ---" },
        // { value: "EXP", text: "Expired"},
        // { value: "CAN", text: "Cancel"},
        // { value: "INV", text: "Inventory"},
        { value: "LIV", text: "Live" },
        { value: "ICP", text: "Incomplete Payment" },
        { value: "RRD", text: "Ready Release Document" },
        // { value: "PRP", text: "Prospect"},
      ],
      sourceproject: [{ value: "", text: "--- ALL ---" }],
      wostatus: dropdown.woStatus,
    };
  },
  computed: {
    tblFields() {
      const fields = [
        {
          key: "no_kontrak",
          label: "No. Kontrak",
          thStyle: "width:140px",
          sortable: true,
        },
        {
          key: "no_agreement",
          label: "No. Agreement",
          thStyle: "width:140px",
          sortable: true,
        },
        {
          key: "tgl_kontrak",
          label: "Tgl. Kontrak",
          thStyle: "width:190px",
          tdClass: "text-right",
          sortable: true,
        },
        // {
        //   key: "uraian",
        //   label: "Uraian",
        //   thStyle: "width:200px",
        //   sortable: true,
        // },
        {
          key: "startdate",
          label: "Go Live Date",
          thStyle: "width:190px",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "duedate",
          label: "Maturity Date",
          thStyle: "width:190px",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "model_pinjaman",
          label: "Model Pinjaman",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "matauang",
          label: "CCY",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "plafond",
          label: "Plafond",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },

        {
          key: "bunga_tarifthn",
          label: "Bunga(%)",
          thStyle: "width:60px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "tenor",
          label: "Tenor (Bulan)",
          thStyle: "width:80px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "installment_amount",
          label: "Angsuran/bulan",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "denda_tarifhri",
          label: "Tarif Denda(%)",
          thStyle: "width:60px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "bungaod_tarifbln",
          label: "Bunga OD(%) - PRK",
          thStyle: "min-width:100px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "CustCode",
          label: "CIF",
          thClass: "text-center",
          thStyle: "min-width:150px",
          sortable: true,
        },
        {
          key: "CustName",
          label: "Debitur Name",
          thClass: "text-center",
          thStyle: "min-width:150px",
          sortable: true,
        },
        {
          key: "days_over_due",
          label: "DOD",
          // thStyle: "min-width:150px",
          thClass: "text-center",
          tdClass: "text-left",
          sortable: true,
        },
        {
          key: "collectability",
          label: "Kolektibilitas",
          thStyle: "min-width:150px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "wo_status",
          label: "Status",
          thStyle: "min-width:150px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "npf_stop_accrue",
          label: "Status Accrue",
          thStyle: "min-width:150px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "rrd_dt",
          label: "RRD Date",
          thStyle: "min-width:150px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "pjxname",
          label: "Source Project",
          thStyle: "min-width:150px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
      ];
      return fields;
    },
    dimCol() {
      return this.tblData.DimCol;
    },
  },
  async created() {
    // this.isBusy = true;
    // this.data();
    const collSet = {
      tablename: "vwcollector",
      // page: 1,
      // limit: 20,
      // total: 0,
    };
    const collector = await crud.list(collSet);
    collector.map((dt) => {
      this.collectors.push({ value: dt.collector_id, text: dt.crewname });
    });

    const collectability_ = await crud.list({ tablename: 'fincollectability' });
    this.kolStatus = collectability_.reduce((arr = [{ value: "", text: "--- ALL ---" }], item, index) => {
      arr.push({
        value: item.collectability,
        text: item.collectability,
      });
      return arr;
    }, [{ value: "", text: "--- ALL ---" }])
    const projectDt = await project.listbyuser();
    this.sourceproject = projectDt.reduce((arr = [], item, index) => {
      arr.push({
        value: item.pjxkey,
        text: item.pjxname,
      });
      return arr;
    }, [{ value: "", text: "--- ALL ---" }]);

    this.tblData.pjxkey = this.tblData.pjxkey || (this.sourceproject.length > 0 ? this.sourceproject[0].value : '');
    if (this.$route.params && this.$route.params.contract_status) {
      this.tblData.contract_status = this.$route.params.contract_status;
      this.refresh();
    }
  },
  methods: {
    async createVa() {
      try {
        if (this.model.pinjamankey) {
          router.push({
            name: "loan.ecollectiontransactions",
            params: {
              showForm: true,
              showList:false,
              model: this.model
            },
          });
        } else {
          throw new Error("Please select a row");
        }
      } catch (error) {
        toastr.warn(error);

      }
    },
    async pelunasan() {
      if (this.model.pinjamankey) {
        router.push({
          name: "loan.pelunasanfrm",
          params: { pinjamankey: this.model.pinjamankey },
        });
      } else {
        toastr.warn("Please select a row that want to view");
      }
    },
    async addpinjaman() {
      router.push({ name: "loan.pinjamankabfrm" });
    },
    async revisipinjaman(data) {
      if (data) {
        for (const key in data) {
          this.model[key] = data[key];
        }
      }
      if (this.model.pinjamankey) {
        if (this.model.model_pinjaman == "PAB") {
          router.push({
            name: "loan.pinjamanABfrm",
            params: { pinjamankey: this.model.pinjamankey },
          });
        }

        if (this.model.model_pinjaman == "PRK") {
          router.push({
            name: "loan.pinjamanRKfrm",
            params: { pinjamankey: this.model.pinjamankey },
          });
        }
      } else {
        toastr.warn("Please select a row that want to be Edit!");
      }
    },
    async angsuran(data) {
      if (data) {
        for (const key in data) {
          this.model[key] = data[key];
        }
      }
      if (this.model.pinjamankey) {
        if (this.model.model_pinjaman == "PAB") {
          router.push({
            name: "loan.jadwalangsuran",
            params: { pinjamankey: this.model.pinjamankey },
          });
        }

        if (this.model.model_pinjaman == "PRK") {
          toastr.warn("Harap pilih model pinjaman PRK.");
        }
      } else {
        toastr.warn("Please select a row that want to view");
      }
    },
    async harianDtl() {
      if (this.model.pinjamankey) {
        if (this.model.model_pinjaman === "PAB") {
          router.push({
            name: "loan.detaildendaharian",
            params: { pinjamankey: this.model.pinjamankey },
          });
        } else {
          router.push({
            name: "loan.detailbungaharian",
            params: { pinjamankey: this.model.pinjamankey },
          });
        }
      } else {
        toastr.warn("Please select a row that want to view");
      }
    },

    async collectionDtl() { },

    async paymentHistory() {
      if (this.model.pinjamankey) {
        router.push({
          name: "loan.paymenthistory",
          params: { pinjamankey: this.model.pinjamankey },
        });
      } else {
        toastr.warn("Please select a row that want to view");
      }
    },

    async exportDtl() {
      if (this.model.pinjamankey) {
        try {
          await pinjaman.exportDtlxls(this.model.pinjamankey);
        } catch (error) {
          this.isBusy = false;
          if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      } else {
        toastr.warn("Please select a row that want to export detail");
      }
    },

    rowClicked(record, index) {
      if (this.model && this.model._rowVariant) {
        delete this.model._rowVariant;
      }
      if (record.isReturn === 1) {
        this.disabledRetur = true;
      } else {
        this.disabledRetur = false;
      }

      this.model = record;
      record._rowVariant = "info";
      this.$forceUpdate();
    },
    data: async function (ctx) {
      try {
        const list = await pinjaman.list(this.tblData);
        this.isBusy = false;
        return list;
      } catch (error) {
        console.log("error : ", error);
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async refresh() {
      try {
        this.$refs.table.refresh();
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    clearFilter() {
      this.tblData.customer = "";
      this.tblData.collectability = "";
      this.tblData.sourceproject = "";
      this.tblData.collector_id = "";
      this.tblData.model_pinjaman = "";
      this.tblData.tgl1 = "";
      this.tblData.tgl2 = "";
      this.tblData.nomor = "";
      this.tblData.agreement = "";
      this.tblData.dod1 = 0;
      this.tblData.dod2 = 0;
      this.tblData.wo_status = "";
      this.tblData.pjxkey = "";

      this.refresh();
    },
    async exportxls() {
      try {
        await pinjaman.exportxls(this.tblData);
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async stopaccrue() {
      try {
        await pinjaman.stopaccrue(this.model);
        this.refresh();
        toastr.success(`Success,Stop Accrue`, "", 10000);
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async startaccrue() {
      try {
        await pinjaman.startaccrue(this.model);
        this.refresh();
        toastr.success(`Success,Reverse Stop`, "", 10000);
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async writeoff() {
      try {
        await pinjaman.writeoff(this.model);
        this.refresh();
        toastr.success(`Success,Write Off `, "", 10000);
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    close() {
      router.push("home");
    },
  },
};
</script>